var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 583.71 655.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:#fff;}.cls-2{opacity:0.7;}.cls-3{fill:#d41c0d;}.cls-4{fill:#d40613;}.cls-5{font-size:32px;font-family:SourceSansPro-Bold, Source Sans Pro;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landingpage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bubbles"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.65,185.38A145.89,145.89,0,1,0,106.72,5.51,145.9,145.9,0,0,0,5.65,185.38"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.46,185.47A146,146,0,1,0,106.6,5.46a146,146,0,0,0-101.14,180"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.73,548.71a146,146,0,1,0,101.14-180,146,146,0,0,0-101.14,180"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.55,548.83a146,146,0,1,0,101.14-180,146,146,0,0,0-101.14,180"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M284.84,549.85c119.35,39.36,248-25.49,287.36-144.84S546.71,157,427.36,117.65,179.36,143.14,140,262.49s25.49,248,144.84,287.36"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(179.91 308.63)"
  }, "Du als Mitarbeiter stehst ", /*#__PURE__*/React.createElement("tspan", {
    x: 17.94,
    y: 47
  }, "immer im Mittelpunkt "), /*#__PURE__*/React.createElement("tspan", {
    x: 24.22,
    y: 94
  }, "unserer Bem\xFChungen")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/Bubbles.a6d0d70beecb3f11140d5be3af3a1a78.svg";
export { ForwardRef as ReactComponent };